<ngx-spinner size="medium" bdColor="rgba(0,0,0,0.3)" color="#414042" type="ball-clip-rotate">
</ngx-spinner>
<router-outlet></router-outlet>